<template>
  <div>
    <register-title class="form__title">
      {{ $t("branch/representative additional info") }}</register-title
    >
    <div v-if="!open">
      <div class="row" v-if="filials.length > 0">
        <div
          class="col-xs-12"
          v-for="(filial, filial_index) in filials"
          :key="`${filial_index}-filial-body`"
        >
          <div class="rep_minimize" style="margin-top:0px; padding: 15px;">
            <!--            /{{ filial }}-->
            <div class="row">
              <div class="col-xs-12">
                <h2 style="font-weight: normal">
                  {{ filial.name }}
                </h2>
                <h3 style="font-style: italic">
                  {{ filial.address }}
                </h3>
                <div class="col-xs-12"></div>
              </div>
            </div>
            <br />
            <div class="row bottom-xs">
              <div class="col-xs ">
                <span
                  style="color: #767d8a"
                  @click="deleteFilial(filial, filial_index)"
                >
                  {{ $t("delete") }}
                </span>
              </div>
              <div class="col-xs-8 end-xs">
                <span style="color: #1a75e9" @click="goEditFilial(filial)">
                  {{ $t("change") }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-xs-12">
          <div class="rep_minimize" style="margin-top:0px; padding: 15px;">
            <h2 style="font-weight: normal; color: #767d8a">
              {{ $t("empty list") }}
            </h2>
          </div>
        </div>
      </div>
      <div class="row" @click="open = !open">
        <div class="col-xs-12">
          <div class="rep_minimize" style="margin-top:0px; padding: 15px;">
            <h2 style="font-weight: normal; color: #1a75e9">
              {{ $t("add") }} {{ $t("info").toLowerCase() }}
            </h2>
          </div>
        </div>
      </div>
      <button class="button form__button" @click="nextStep">
        {{ $t("continue") }}
      </button>
    </div>
    <form v-else @submit.prevent="handleFormSubmit">
      <register-input
        componentID="user-first-name"
        :label="$t('branch name')"
        :inputPlaceholder="$t('branch name')"
        inputType="text"
        :isRequired="true"
        class="form__input"
        v-model="form.name"
      />
      <register-input
        componentID="user-first-name"
        :label="$t('bin (if available)')"
        :inputPlaceholder="$t('bin (if available)')"
        inputType="text"
        :isRequired="false"
        class="form__input"
        :inputMaxLength="12"
        v-model="form.bin"
      />
      <div class="select-container">
        <label class="label">{{ $t("document type register confirm") }}</label>
        <exp-select
          :options="registrationDocumentTypesList"
          v-model="form.document_type"
          title="Выберите страну"
        ></exp-select>
      </div>
      <register-input
        v-model="form.issued_at"
        componentID="issue-date"
        inputType="date"
        :maxDate="new Date()"
        label="Дата выдачи"
        :isRequired="true"
        class="form__input"
      />
      <register-input
        componentID="user-first-name"
        :label="$t('body register name')"
        :inputPlaceholder="$t('body register name')"
        inputType="text"
        :isRequired="true"
        class="form__input"
        v-model="form.register_author"
      />
      <register-input
        v-model="form.register_date"
        componentID="issue-date"
        inputType="date"
        :maxDate="new Date()"
        :label="$t('register date (re-register)')"
        :isRequired="true"
        class="form__input"
      />
      <register-input
        componentID="user-first-name"
        :label="$t('register location')"
        :inputPlaceholder="$t('register location')"
        inputType="text"
        :isRequired="true"
        class="form__input"
        v-model="form.register_place"
      />
      <register-input
        componentID="user-first-name"
        :label="$t('buss activity type')"
        :inputPlaceholder="$t('buss activity type')"
        inputType="text"
        :isRequired="true"
        class="form__input"
        v-model="form.activity_type"
      />
      <register-input
        componentID="user-first-name"
        :label="$t('registered address of the branch (representative office)')"
        :inputPlaceholder="
          $t('registered address of the branch (representative office)')
        "
        inputType="text"
        :isRequired="true"
        class="form__input"
        v-model="form.address"
      />

      <div class="input-container">
        <label for="user-phone" class="label">
          {{ $t("mobile number") }}
          <span class="red">*</span>
        </label>
        <input
          type="tel"
          class="input form__input"
          :placeholder="$t('mobile number')"
          required
          maxlength="16"
          id="user-phone"
          v-model="form.phone"
          @keyup="formatPhone"
          @blur="formatPhone"
        />
      </div>
      <register-input
        componentID="user-email"
        :label="$t('email address')"
        inputType="email"
        :inputPlaceholder="$t('email address')"
        class="form__input"
        :isRequired="true"
        v-model="form.email"
      />
      <button class="button filled form__button">{{ $t("save") }}</button>
    </form>
  </div>
</template>
<script>
import regFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";
export default {
  props: ["body_member_data"],
  name: "MainRegForm",
  data() {
    return {
      old_form: {},
      open: false,
      selected: 0,
      // form: null,
      filials: [],
      form: {
        bin: null,
        name: null,
        document_type: null,
        issued_at: null,
        register_author: null,
        register_date: null,
        register_place: null,
        activity_type: null,
        address: null,
        phone: null,
        email: null
      },
      form_dates: ["issued_at", "register_date"]
    };
  },
  mixins: [regFormMixin],
  methods: {
    formatPhone() {
      let num = this.form.phone.replace(/\D/g, "").split(/(?=.)/);
      let i = num.length - 1;
      if (0 <= i) num.unshift("+");
      if (1 <= i) num.splice(2, 0, " ");
      if (4 <= i) num.splice(6, 0, " ");
      if (7 <= i) num.splice(10, 0, "-");
      if (9 <= i) num.splice(13, 0, "-");
      this.form.phone = num.join("");
    },
    isFormChanged() {
      return JSON.stringify(this.old_form) !== JSON.stringify(this.form);
    },
    fetchForm() {
      try {
        FhsAxios.get(`profile/filials`).then(res => {
          if (res.data.status) {
            this.filials = res.data.result || [];
            this.form_dates.forEach(date => {
              this.form[date] = this.dateFormat(this.form[date]);
            });
            // this.from = res.data.result;
          }
        });
        // console.log(this.isKazDoc(this.form.document_type));
        this.old_form = JSON.parse(JSON.stringify(this.form));
      } catch (e) {
        // ERROR HANDLER
      }
    },
    nextStep() {
      this.$router.push({ name: "income-info" });
    },
    saveData() {
      let url = `profile/filial${
        this.selected !== 0 ? "/" + this.selected : ""
      }`;
      const form = JSON.parse(JSON.stringify(this.form));
      this.form_dates.forEach(date => {
        form[date] = this.dateReFormat(form[date]);
      });
      form.user_control_id = this.$route.params.control_id;
      FhsAxios.post(url, form).then(res => {
        if (res.data.status) {
          this.fetchForm();
          this.$toasted.success(this.$t("data saved"));
          this.selected = 0;
          this.open = false;
          return;
        }
        this.$toasted.error(this.$t("error"));
        this.$emit("loading-status", false);
      });
    },
    goEditFilial(item) {
      // console.log("???");
      this.selected = item.id;
      this.open = !this.open;
      this.form = item;
      this.form_dates.forEach(date => {
        this.form[date] = this.dateFormat(this.form[date]);
      });
    },
    deleteFilial(item, index) {
      let url = `profile/filial/${item.id}/delete`;
      FhsAxios.post(url).then(res => {
        if (res.data.status) {
          this.filials.splice(index, 1);
          this.$toasted.clear();
          this.$toasted.show(this.$t("deleted"));
        } else {
          this.$toasted.show(this.$t("error save"));
        }
      });
    },
    handleFormSubmit() {
      if (!this.isFormChanged()) {
        this.nextStep();
      } else {
        this.saveData();
      }
    }
  },
  beforeMount() {
    this.fetchForm();
  }
};
</script>
